import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import SavingStates from "../../constants/states/SavingStates";
import PhoneNumberVerificationViewStore from "../../stores/PhoneNumberVerificationViewStore";
import PhoneNumberVerificationView from "../views/PhoneNumberVerificationView";
import PropTypes from "prop-types";


class PhoneNumberVerificationContainer extends React.Component {

    static propTypes = {
        phoneNumber: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            "phoneNumberVerificationViewStoreState": PhoneNumberVerificationViewStore.getState()
        };
    }

    componentDidMount() {
        this.phoneNumberVerificationStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PHONE_NUMBER_VERIFICATION_VIEW_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.PHONE_NUMBER_VERIFICATION_SMS_REQUESTED, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.phoneNumberVerificationStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "phoneNumberVerificationViewStoreState": PhoneNumberVerificationViewStore.getState()
        });
    };

    render() {
        return (
            <PhoneNumberVerificationView
                phoneNumber={this.props.phoneNumber}
                isCheckingCode={this.state.phoneNumberVerificationViewStoreState.codeCheckState === SavingStates.SAVING}
                isRequestingSMS={this.state.phoneNumberVerificationViewStoreState.smsSendState === SavingStates.SAVING}
                validationCode={this.state.phoneNumberVerificationViewStoreState.validationCode}
            />
        );
    }

}

export default PhoneNumberVerificationContainer;